import storage from '@/modules/storage';
import { webCampaign } from '@/modules/webCampaign';

export const removeAllDataAndStartOver = async () => {
  await storage.clear();
  localStorage.clear();

  const redirectUrl = webCampaign.isDomainDefaultCampaign()
    ? `${window.location.origin}/`
    : `${window.location.origin}/?web_campaign=${webCampaign.getKey()}`;
  window.location.assign(redirectUrl);
};
